<template>
  <v-dialog
      content-class="annotationInfoDialog"
      :value="value"
      @input="(v) => v || close()"
      hide-overlay
      persistent
      no-click-animation
      transition="slide-x-reverse-transition"
      max-width="330px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">アノテーション</span>
        <v-spacer></v-spacer>
        <v-btn light fab small depressed v-on:click="close">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container class="pb-0">
          <v-form>
            <v-select
                disabled
                hide-details="auto"
                v-model="info.type"
                label="異常種類"
                outlined
                dense
                :items="types"
                readonly
                append-icon=""
            ></v-select>
            <v-select
                disabled
                hide-details="auto"
                v-model="info.reason"
                label="原因"
                outlined
                dense
                :items="reasons"
                readonly
                append-icon=""
            ></v-select>
            <h4>異常の位置：</h4>
            <span v-if="info.coordinates">{{ info.coordinates[1].toFixed(6) }}, {{ info.coordinates[0].toFixed(6) }}</span>
          </v-form>
          <h4 class="mt-2">異常個所周辺の画像：</h4>
          <v-row class="mt-2">
            <v-col cols="3" v-for="(item, index) in info.thermalImages" :key="item.src" class="image-container" @click="displayImages(index, 'thermal')">
              <v-img
                  lazy-src="@/assets/images/no-image.png"
                  class="image"
                  max-height="100"
                  aspect-ratio="1"
                  :src="item.src">
                <template v-slot:placeholder>
                  <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                  >
                    <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
<!--                <div class="d-flex justify-end" v-if="!Array.isArray(item.crop) || !Array.isArray(item.annotation_mark)">-->
<!--                  <div style="background: rgba(245,245,245,1); border-radius: 50%;">-->
<!--                    <v-icon :color="!Array.isArray(item.crop) ? 'primary' : 'deep-orange darken-2'">mdi-checkbox-marked-circle</v-icon>-->
<!--                  </div>-->
<!--                </div>-->
              </v-img>
              <div class="icon">
                <v-icon>
                  mdi-magnify-plus-outline
                </v-icon>
              </div>
            </v-col>
            <v-col cols="3" v-for="(item, index) in info.colorImages" :key="item.src" class="image-container" @click="displayImages(index, 'color')">
              <v-img
                  lazy-src="@/assets/images/no-image.png"
                  class="image"
                  max-height="100"
                  aspect-ratio="1"
                  :src="item.src">
                <template v-slot:placeholder>
                  <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                  >
                    <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
<!--                <div class="d-flex justify-end" v-if="!Array.isArray(item.crop) || !Array.isArray(item.annotation_mark)">-->
<!--                  <div style="background: rgba(245,245,245,1); border-radius: 50%;">-->
<!--                    <v-icon :color="!Array.isArray(item.crop) ? 'primary' : 'deep-orange darken-2'">mdi-checkbox-marked-circle</v-icon>-->
<!--                  </div>-->
<!--                </div>-->
              </v-img>
              <div class="icon">
                <v-icon>
                  mdi-magnify-plus-outline
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AnnotationViewDialog",
  props: ['value', 'info'],
  data(){
    return {
      types: [
        { text: "ホットスポット", value: "cell" },
        { text: "マルチホットスポット", value: "multicell" },
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module" },
        { text: "ストリング異常", value: "string" },
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        { text: "影", value: "shadow" },
      ],
      reasons: [
        { text: '不明', value: null},
        { text: "割れ", value: "crack" },
        { text: "堆積物", value: "sediment" },
        { text: "植生", value: "vegetation" },
      ],
    }
  },

  methods: {
    close(){
      this.$emit('input');
    },
    displayImages(position, imageType){
      if (imageType === 'thermal'){
        this.$emit('displayAnnotationImages', this.info.coordinates, this.info.thermalImages, position, imageType);
      }
      if (imageType === 'color'){
        this.$emit('displayAnnotationImages', this.info.coordinates, this.info.colorImages, position, imageType);
      }
    },
  }
}
</script>

<style scoped>
.image-container{
  position: relative;
  padding: 2px;
}

>>>.v-select__selection--disabled, >>>.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}

>>>.annotationInfoDialog{
  position: absolute;
  top: 150px;
  left: 280px;
  margin: 0px;
}

.icon{
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image-container:hover .icon{
  opacity: 1;
}

.image-container:hover .image{
  opacity: 0.3;
}
</style>
